/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2025, Zumper
 * @description ListingCardReview
 */

import type { CardBackReview } from '@zcode/state-type'
import { format } from 'date-fns'

interface ListingCardReviewProps {
  isSpotlight?: true
  review: CardBackReview
}

export const ListingCardReview = ({ isSpotlight, review }: ListingCardReviewProps) => {
  const { text, timestamp, name } = review

  if (!text) {
    return null
  }

  const nameText = name ? `${name} on ` : ''

  return (
    <div
      className={`flex flex-col gap-y-1 text-sm ${isSpotlight ? 'text-neutral-200' : 'text-gray-600'}`}
    >
      <div className={`font-bold ${isSpotlight ? 'text-gray-0' : 'text-gray-950'}`}>
        Review from the web
      </div>
      <p className="line-clamp-4">{text}</p>
      <div>
        - {nameText}
        {timestamp && format(new Date(timestamp * 1000), 'MMM d, y')}
      </div>
    </div>
  )
}
